import Vue from 'vue';
import i18n from '@/i18n';

function SaqueStatus(value: string) {
  switch (value) {
    case 'rejeitado':
      return i18n.t('saques.situacoes.rejeitado');
    case 'cancelado':
      return i18n.t('saques.situacoes.cancelado');
    case 'pendente':
      return i18n.t('saques.situacoes.pendente');
    case 'pago':
      return i18n.t('saques.situacoes.pago');
    default:
      return '-';
  }
}

function SaqueCor(value: string, prefix = '') {
  switch (value) {
    case 'rejeitado':
      return `${prefix}danger`;
    case 'cancelado':
      return `${prefix}danger`;
    case 'pendente':
      return `${prefix}warning`;
    case 'pago':
    default:
      return 'light';
  }
}

function SaqueBadge(value: string, prefix = '') {
  switch (value) {
    case 'rejeitado':
      return `${prefix}danger`;
    case 'cancelado':
      return `${prefix}danger`;
    case 'pendente':
      return `${prefix}warning`;
    case 'pago':
    default:
      return `${prefix}soft-secondary`;
  }
}

Vue.filter('SaqueStatus', SaqueStatus);
Vue.filter('SaqueCor', SaqueCor);
Vue.filter('SaqueBadge', SaqueBadge);
